import { Base, importWhenVisible } from '@studiometa/js-toolkit';
import { Action, Tabs } from '@studiometa/ui';
import Slider from './Slider/index.js';
import Instagram from './Instagram/index.js';
import ProductLastViewed from './ProductLastViewed.js';
import Tooltips from './Tooltips.js';
import HeroSlider from './HeroSlider.js';
import LogoSlider from './LogoSlider.js';

/**
 * Sections component
 */
export default class Sections extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Sections',
    components: {
      Action,
      Tabs,
      Slider,
      Instagram,
      ProductLastViewed,
      Tooltips,
      HeroSlider,
      LogoSlider,
      VideoLinks: (app) => importWhenVisible(() => import('./VideoLinks.js'), 'VideoLinks', app),
      CollectionLinks: (app) =>
        importWhenVisible(() => import('./CollectionLinks.js'), 'CollectionLinks', app),
      ProductRecommendations: (app) =>
        importWhenVisible(
          () => import('./ProductRecommendations.js'),
          'ProductRecommendations',
          app,
        ),
      HeroLanding: (app) => importWhenVisible(() => import('./HeroLanding.js'), 'HeroLanding', app),
      Video: (app) => importWhenVisible(() => import('./Video.js'), 'Video', app),
      VideoCover: (app) => importWhenVisible(() => import('./VideoCover.js'), 'VideoCover', app),
      StoreLocator: (app) =>
        importWhenVisible(() => import('./StoreLocator/index.js'), 'StoreLocator', app),
      Accordion: (app) => importWhenVisible(() => import('./Accordion/index.js'), 'Accordion', app),
      ZoomedGallery: (app) =>
        importWhenVisible(
          () => import('../Shop/Product/ZoomedGallery/index.js'),
          'ZoomedGallery',
          app,
        ),
      SliderImagesGallery: (app) =>
        importWhenVisible(() => import('./SliderImagesGallery.js'), 'SliderImagesGallery', app),
      Faq: (app) => importWhenVisible(() => import('./Faq/index.js'), 'Faq', app),
      StickyMediaContent: (app) =>
        importWhenVisible(() => import('./StickyMediaContent.js'), 'StickyMediaContent', app),
      CollectionNav: (app) =>
        importWhenVisible(() => import('./CollectionNav.js'), 'CollectionNav', app),
      ReadMore: (app) => importWhenVisible(() => import('./ReadMore.js'), 'ReadMore', app),
      PconConfigurator: (app) =>
        importWhenVisible(() => import('./PconConfigurator.js'), 'PconConfigurator', app),
    },
  };
}
